__turbopack_context__.v({
  "root": "ImageModal-module__LT8QHW__root",
});
